:host {
  display: inline-block;
  /** @prop --product-illustration-size: Set the size of the product illustration. */
  --product-illustration-size: 2rem;

  /** @prop --size: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --size: var(--product-illustration-size);

  /** @prop --product-illustration-color: Set the color of the product illustration. */
  --product-illustration-color: currentColor;

  /** @prop --color: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --color: var(--product-illustration-color);

  /** @prop --product-illustration-stroke-width: Set the stroke width of the product illustration. */
  --product-illustration-stroke-width: 2px;

  /** @prop --stroke-width: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --stroke-width: var(--product-illustration-stroke-width);
}

.anchor-c-product-illustration {
  width: var(--product-illustration-size);
  height: var(--product-illustration-size);
  fill: var(--product-illustration-color);
  stroke: var(--product-illustration-color);
  stroke-width: var(--product-illustration-stroke-width);
  stroke-linecap: round;
}

.small {
  --product-illustration-size: 2rem;
}

.medium {
  --product-illustration-size: 3rem;
}

.large {
  --product-illustration-size: 4rem;
}

.xlarge {
  --product-illustration-size: 6rem;
}
